namespace AgerLMS.WebSite {

    export interface LoginWidgetRequest {
        Username?: string;
        Password?: string;
        recaptcha?: string;
        dm?: boolean;
    }

    @Serenity.Decorators.registerClass()
    export class LoginWidget extends Serenity.Widget<LoginWidgetRequest> {

        button : string = "#LoginButton";
        formSelector : string = "#LoginForm";

        constructor(element: JQuery, opt: LoginWidgetRequest) {
            super(element, opt);

            this.bindValidate();

            $(this.button).click(e => {
                e.preventDefault();

                if (!$(this.formSelector).valid()) return;

                let request = <LoginWidgetRequest>{};
                request.Username = $("input#username").val();
                request.Password = $("input#password").val();
                if (this.options.dm == false) 
                    request.recaptcha = $("input#grecaptcha").val();

                Q.serviceCall({
                    url: Q.resolveUrl('~/Account/Login'),
                    request: request,
                    onSuccess: response => {
                        this.redirectToReturnUrl(request.Username);
                    },
                    // onError: (response: Serenity.ServiceResponse) => {
                    //     SweetAlert.swal_alert(response.Error.Message, response.Error.Message)
                    // }
                    onError: (response: Serenity.ServiceResponse) => {
                        if (response != null && response.Error != null && response.Error.Code == "TwoFactorAuthenticationRequired") {
                            var args = response.Error.Arguments.split('|');
                            this.handleTwoFactorAuthentication(request.Username, request.Password, args[1], args[0]);
                            return;
                        }

                        if (response != null && response.Error != null && response.Error.Code == "RedirectUserTo") {
                            window.location.href = response.Error.Arguments;
                            return;
                        }

                        if (response != null && response.Error != null && !Q.isEmptyOrNull(response.Error.Message)) {
                            // Q.notifyError(response.Error.Message);
                            SweetAlert.swal_alert("HATA", response.Error.Message)
                            $('#Password').focus();

                            return;
                        }

                        SweetAlert.swal_alert("HATA", response.Error.Message)
                        // Q.ErrorHandling.showServiceError(response.Error);
                    }
                });
            });

            $(document).keypress(function(e){
                if (e.which == 13){
                    $(this.button).click();
                }
            });
        }

        private bindValidate() {
            var self = this;

            $(".reveal").on('click',function() {
                var $password = $(this).parent().children("input");
                var $i = $(this).children().children("i");
                if ($password.attr('type') === 'password') {
                    $password.attr('type', 'text');
                    $i.removeClass("fa-eye-slash");
                    $i.addClass("fa-eye");
                } else {
                    $password.attr('type', 'password');
                    $i.removeClass("fa-eye");
                    $i.addClass("fa-eye-slash");
                }
            });
            
            //phone number or email validation
            $.validator.addMethod('checkUsername', function(value, element) {
                return value.match(/05[0-9]{8}/) || value.match(/\S+@\S+\.\S+/);
            },"* Lütfen telefon numarası veya e-posta girin.");

            let r = {
                username: {
                    required: true,
                    checkUsername: true
                },
                password: {
                    required: true,
                    maxlength: 20
                }
            };
            let m = {
                username: {
                    required: "* Lütfen telefon numarası veya e-posta girin.",
                    checkUsername:"* Lütfen geçerli telefon numarası veya e-posta girin."
                },
                password: {
                    required: "* Şifrenizi belirtin",
                    maxlength:"* Şifreniz en fazla 20 karakter olabilir."
                }
            };

            if (this.options.dm == false) 
                RT.recaptchaInclude(this.options.recaptcha, $(self.button), r, m);

            $(this.formSelector).validate({
                errorClass: "is-invalid",
                rules: r,
                messages: m,
                errorPlacement: function(error, element) {
                    $(element).parents('.form-group').append(error)
                }
            });
        }

        protected redirectToReturnUrl(username : string) {
            var q = Q.parseQueryString();
            var returnUrl = q['returnUrl'] || q['ReturnUrl'];
            if (returnUrl) {
                var hash = window.location.hash;
                if (hash != null && hash != '#')
                    returnUrl += hash;
                window.location.href = returnUrl;
            }
            else {
                //window.location.href = Q.resolveUrl("~/");
                Administration.PublicUserService.DecideUserRedirect({}, (response) => {
                        let r = <Serenity.RetrieveResponse<string>>response;
                        window.location.href = Q.resolveUrl(r.Entity);
                    }, { onError: (response: Serenity.ServiceResponse) => { 
                        SweetAlert.swal_alert("HATA", response.Error.Message)
                    }}
                );
            }
        }

        protected handleTwoFactorAuthentication(user: string, pass: string, twoFactorGuid: string, info: string) {
            var tries = 0;
            let timerInterval
            var sw = Swal.fire({
                title: 'İki Faktörlü Kimlik Doğrulama',
                html: info,
                timer: 2 * 60 * 1000,
                timerProgressBar: true,
                input: 'text',
                inputAttributes: {
                  autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonText: 'Kodu Onayla',
                cancelButtonText: 'İptal',
                showLoaderOnConfirm: true,
                didOpen: () => {
                    const b = Swal.getHtmlContainer().querySelector('span.counter')
                    timerInterval = setInterval(() => {
                      b.textContent = (Swal.getTimerLeft() / 1000).toFixed(0);
                    }, 1000)
                },
                willClose: () => {
                    clearInterval(timerInterval)
                },
                preConfirm: (x) => {
                    if (x >= 1000 && x <= 9999) {
                        tries++;
                        
                        Q.serviceCall({
                            url: Q.resolveUrl('~/Account/Login'),
                            request: {
                                Username: user,
                                Password: pass,
                                TwoFactorGuid: twoFactorGuid,
                                TwoFactorCode: x
                            },
                            onSuccess: (r) => {
                                this.redirectToReturnUrl(user);
                                return true;
                            },
                            onError: (z: Serenity.ServiceResponse) => {
                                if (tries > 2) {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Oops...',
                                        text: 'Girilen kod geçersiz! 3 defadan fazla deneyemezsiniz!',
                                      })
                                    return true;
                                }
                                Swal.showValidationMessage(`${z.Error.Message}`)
                            }
                        });
                
                        return false;
                    }
                    else Swal.showValidationMessage(`Lütfen geçerli bir kod girin!`)
                },
                allowOutsideClick: () => !Swal.isLoading(),
            }).then(r => {
                Q.notifyInfo(JSON.stringify(r));
            });


        }
    }
}